import { get } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';

let baseUrl = 'payments';

const NBXPayments = {
  init: config => ({ baseUrl } = config),

  getDeposits: (args = {}) => {
    const { asset } = args;
    return context.account().then(account => {
      return get(`${baseUrl}/accounts/${account.id}/assets/${asset}/deposits`, account);
    });
  },
  getTaxReport: year => context.account().then(account => get(`${baseUrl}/tax-report/${year}`, account))
};

export default NBXPayments;
